import { gql } from "@apollo/client";

export const GET_ALL_TIPO_DOCUMENTO = gql`
query GetAllTipoDocumento {
    allTipoDocumento
    {
        descripcion,
        idTipoDocumento,
    }
}`;


export const adaptTipoDocumento = (tipoDoc) => ({
  id: tipoDoc.idTipoDocumento,
  displayName: tipoDoc.descripcion
});

export const adaptTipoDocumentoArray = (tipos) =>
structuredClone(tipos?.allTipoDocumento)?.
map((tipo) => adaptTipoDocumento(tipo));